// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"95da5460","280":"28a145df","449":"e882bb42","869":"3c3d69b5"}[chunkId] + ".chunk.css";
};